/* ============================================================
   CATERPY FOR BUSINESS - 自動スライダー + メーター
   ============================================================ */

(function () {
  'use strict';

  document.querySelectorAll('[data-biz-slider]').forEach(function (slider) {
    var slidesWrap = slider.querySelector('[data-biz-slides]');
    var slides = slider.querySelectorAll('.caterpy-biz__slide');
    var bars = slider.querySelectorAll('.caterpy-biz__meter-bar');
    var fills = slider.querySelectorAll('[data-biz-meter-fill]');

    if (slides.length <= 1) return;

    var duration = parseInt(slider.getAttribute('data-autoplay-duration'), 10) || 5;
    var durationMs = duration * 1000;
    var currentIndex = 0;
    var autoTimer = null;
    var startTime = null;
    var rafId = null;

    function setActive(index) {
      currentIndex = index;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      bars.forEach(function (b, i) {
        b.classList.toggle('is-active', i === index);
        b.classList.toggle('is-done', i < index);
      });
      resetFills();
      startProgress();
    }

    function resetFills() {
      fills.forEach(function (fill, i) {
        if (i < currentIndex) {
          fill.style.width = '100%';
        } else if (i === currentIndex) {
          fill.style.width = '0%';
        } else {
          fill.style.width = '0%';
        }
      });
    }

    function startProgress() {
      cancelAnimationFrame(rafId);
      clearTimeout(autoTimer);
      startTime = performance.now();

      var activeFill = fills[currentIndex];
      if (!activeFill) return;

      function tick(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / durationMs, 1);
        activeFill.style.width = (progress * 100) + '%';

        if (progress < 1) {
          rafId = requestAnimationFrame(tick);
        } else {
          next();
        }
      }

      rafId = requestAnimationFrame(tick);
    }

    function next() {
      var nextIndex = (currentIndex + 1) % slides.length;
      setActive(nextIndex);
    }

    function pause() {
      cancelAnimationFrame(rafId);
      clearTimeout(autoTimer);
    }

    // メーターバークリックで手動切替
    bars.forEach(function (bar) {
      bar.addEventListener('click', function () {
        var index = parseInt(bar.getAttribute('data-biz-meter-index'), 10);
        if (isNaN(index)) return;
        setActive(index);
      });
    });

    // ホバーで一時停止
    slider.addEventListener('mouseenter', pause);
    slider.addEventListener('mouseleave', startProgress);

    // 初期化
    setActive(0);
  });
})();